// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1o-75","info":"UpdateTermsInfo_info__nYKIT"};